import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-plus',
  templateUrl: './icon-plus.component.html',
  styleUrls: ['./icon-plus.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconPlusComponent {}
